export { default } from "./Switch.js";
export { default as switchClasses } from "./switchClasses.js";
export * from "./switchClasses.js";